module.exports = __webpack_public_path__ + "static/media/loading.202a368c.gif";